import { useState, useEffect, useMemo } from 'react';
import { filterByWord } from '@/utils/global';
import CandidateFilterAutocompleteComponent, {
  AutocompleteComponentType,
} from './CandidateFilterAutocomplete.component';

export type AutoCompleteProps = Pick<
  AutocompleteComponentType,
  'withSearch' | 'options' | 'onRemoveFilterOption' | 'selectedOptions' | 'groupedOptions'
> & {
  onSelectFilterOption: (value: string | number | Date | any[]) => void;
};

const CandidateFilterAutocomplete = ({
  options,
  onRemoveFilterOption,
  withSearch,
  selectedOptions,
  groupedOptions,
  onSelectFilterOption,
}: AutoCompleteProps): JSX.Element => {
  const [input, setInput] = useState('');

  useEffect(() => {
    setInput('');
  }, [options]);

  const onSelectItem = (value: string | number | Date | string[]): void => {
    onSelectFilterOption(value);
  };

  const filteredOptions = useMemo(() => {
    if (!input) {
      return options;
    }

    return options.filter((option) => {
      const valueAsString = option.value.toString();
      return filterByWord(valueAsString, input);
    });
  }, [options, input]);

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { value },
    } = event;
    setInput(value);
  };
  return (
    <CandidateFilterAutocompleteComponent
      onChangeInput={onChangeInput}
      onRemoveFilterOption={onRemoveFilterOption}
      withSearch={withSearch}
      options={filteredOptions}
      input={input}
      groupedOptions={groupedOptions}
      selectedOptions={selectedOptions}
      onSelectItem={onSelectItem}
    />
  );
};

export default CandidateFilterAutocomplete;
